import { __rest } from "tslib";
import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
function convertNodeToOption(node) {
    const _a = node, { key } = _a, _b = _a.props, { children, value } = _b, restProps = __rest(_b, ["children", "value"]);
    return Object.assign({ key, value: value !== undefined ? value : key, children }, restProps);
}
export function convertChildrenToData(nodes, optionOnly = false) {
    return toArray(nodes)
        .map((node, index) => {
        if (!React.isValidElement(node) || !node.type) {
            return null;
        }
        const _a = node, { type: { isSelectOptGroup }, key } = _a, _b = _a.props, { children } = _b, restProps = __rest(_b, ["children"]);
        if (optionOnly || !isSelectOptGroup) {
            return convertNodeToOption(node);
        }
        return Object.assign(Object.assign({ key: `__RC_SELECT_GRP__${key === null ? index : key}__`, label: key }, restProps), { options: convertChildrenToData(children) });
    })
        .filter(data => data);
}
